<script setup lang="ts">
definePageMeta({ layout: 'default' })

const { initLenis, destroyLenis } = useLenis()

onMounted(() => initLenis())
onUnmounted(() => destroyLenis())
</script>

<template>
  <div class="overflow-hidden">
    <LandingNav />
    <LandingHome />
    <LandingFeature />
    <LandingPartner />
    <LandingFaq />
    <LandingFooter />
  </div>
</template>
